import { styled } from 'goober'

const Label = styled('label')`
  display: block;
  margin-bottom: .3em;
`

export default Label
